import { Component, Input, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { saveAs as importedSaveAs } from "file-saver";
import { HttpService } from '../../services/http.service';
import { AuthenService } from '../../services/authen.service';
import { HelperService } from '../../services/helper.service';
import { UploadFileDialogComponent } from "../../dialogs/upload-file-dialog/upload-file-dialog";

@Component({
    selector: 'attached-files',
    templateUrl: './attached-files.html',
    styleUrls: ['./attached-files.css']
})
export class AttachedFilesComponent implements OnInit {
    @ViewChild('dlgUpload') dlgUpload: UploadFileDialogComponent;
    @Input() requestCode: string;
    @Input() isView: boolean = true;
    @Input() viewTab: string;
    @Input() statusId: number;
    prnCode: string = 'ZPV';
    files: any = null;
    waiting: boolean = false;
    counterFileExistsMessage: string = "";
    userRole: string = "";

    constructor(private cdr: ChangeDetectorRef, private http: HttpService, private auth: AuthenService, private helper: HelperService) {
        this.prnCode = auth.Principal;
        this.userRole = auth.GroupUserCode;
        debugger;
        //console.log(this.prnCode);
        //console.log(this.requestCode);
    }

    ngOnInit() {
        if (this.requestCode != null && this.requestCode.length > 0)
            this.load(this.viewTab);
    }

    load(mode: string) {
        if (mode != 'Detail' && mode != 'DetailHS') {
            this.http.get(`api/LinkFile/GetTechDocList/${this.requestCode}/${this.prnCode}`, res => {
                //console.log(res.Result);
                this.files = res.Result;
                this.cdr.detectChanges();
            });
        } else {
            this.http.get(`api/LinkFile/GetRequestDocList/${this.requestCode}/${this.prnCode}`, res => {
                //console.log(res.Result);
                //debugger;
                this.files = res.Result;
                this.cdr.detectChanges();
            });
        }
 
    }

    isAllowAdd() {

        if (this.requestCode == '')
            return false;
        if (this.viewTab == 'Detail') {
            if (this.auth.GroupUserCode == 'HS' || (this.auth.GroupUserCode != 'HS' && this.statusId != 1 && this.statusId != 9 && this.statusId != 3 && this.statusId != 24))
                return false;
            else
                return true;
        } else if (this.viewTab == 'DetailHS')
        {
            return true;
        } else {



            if (this.auth.isPrincipal)
                return true;
            else
                return !this.isView;
        }
    }

    isAllowRemove(p: any) {
        //console.log(p.PrincipalGroup);

        if (this.auth.isPrincipal)
            return p.PrincipalGroup == this.prnCode ? true : false;
        else
            return true;
    }

    onAdd() {
        let params = [];
        params.push({ 'requestCode': this.requestCode });
        params.push({ 'userCode': this.auth.GroupUserCode });
        params.push({ 'userName': this.auth.getUser() });
        params.push({ 'viewTab': this.viewTab });
        //this.waiting = true;
        this.dlgUpload.show(params, () => {
            this.load(this.viewTab);
           // this.waiting = false;
            this.cdr.detectChanges();
        });
    }

    onDownload(p: any) {
        if (this.viewTab != 'Detail' && this.viewTab != 'DetailHS') {
           // this.waiting = true;
            this.http.download(`api/LinkFile/DownloadTechDoc/${p.Id}`, res => {
                importedSaveAs(res, p.DocumentName);
              //  this.waiting = false;
                this.cdr.detectChanges();
            });
        } else {
           // this.waiting = true;
            this.http.download(`api/LinkFile/DownloadRequestDoc/${p.Id}`, res => {
                //debugger;
                importedSaveAs(res, p.DocumentName);
               // this.waiting = false;
                this.cdr.detectChanges();
            });
        }
    }

    onRemove(p: any) {
        this.helper.confirm('Are you sure you want to remove this file ?', () => {
            if (this.viewTab != 'Detail' && this.viewTab != 'DetailHS') {
                this.http.delete('api/LinkFile/RemoveTechDoc/' + p.Id, res => {
                    if (res.Result == true)
                        this.load(this.viewTab);
                });
            } else {
                this.http.delete('api/LinkFile/RemoveRequestDoc/' + p.Id, res => {
                    if (res.Result == true)
                        this.load(this.viewTab);
                });
            }
        });
    }

    onDownloadZIP() {
       // this.waiting = true;
        this.http.download(`api/LinkFile/ZipNDownloadRequestDocList/${this.requestCode}/${this.prnCode}`, res => {
            importedSaveAs(res, "RequestDocs.zip");
           // this.waiting = false;
            this.cdr.detectChanges();
        });
    }




}
